(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kas-home-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class KasHeroSliderV2 extends HTMLElement {
      connectedCallback() {
        if (!this.kasInitialized) this.initialize();
        this.bindDocumentEvents();
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        this.unbindDocumentEvents();
      }

      initialize() {
        this.slides = Array.from(this.querySelectorAll('[data-kas-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-kas-dot]'));
        this.previousButton = this.querySelector('[data-kas-prev]');
        this.nextButton = this.querySelector('[data-kas-next]');
        this.status = this.querySelector('[data-kas-status]');
        this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        this.interval = Math.max(Number.parseInt(this.dataset.interval, 10) || 5000, 3000);
        this.activeIndex = Math.max(this.slides.findIndex((slide) => slide.classList.contains('is-active')), 0);
        this.pointerStartX = null;
        this.suppressBannerLink = false;
        this.timer = undefined;

        this.handlePrevious = () => {
          this.show(this.activeIndex - 1);
          this.start();
        };
        this.handleNext = () => {
          this.show(this.activeIndex + 1);
          this.start();
        };
        this.handleVisibility = () => {
          if (document.hidden) this.stop();
          else this.start();
        };
        this.handleBlockSelect = (event) => {
          const selectedSlide = this.slides.find((slide) => slide.dataset.blockId === event.detail.blockId);
          const selectedBenefit = Array.from(this.querySelectorAll('[data-benefit-id]')).find((benefit) => benefit.dataset.benefitId === event.detail.blockId);
          if (!selectedSlide && !selectedBenefit) return;
          this.stop();
          this.show(selectedSlide ? this.slides.indexOf(selectedSlide) : 0);
        };

        this.previousButton?.addEventListener('click', this.handlePrevious);
        this.nextButton?.addEventListener('click', this.handleNext);
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            this.show(Number.parseInt(dot.dataset.kasDot, 10));
            this.start();
          });
        });

        this.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'touch') return;
          this.pointerStartX = event.clientX;
          this.suppressBannerLink = false;
          this.stop();
        });
        this.addEventListener('pointerup', (event) => {
          if (this.pointerStartX === null || event.pointerType !== 'touch') return;
          const distance = event.clientX - this.pointerStartX;
          this.pointerStartX = null;
          if (Math.abs(distance) >= 45) {
            this.suppressBannerLink = true;
            this.show(this.activeIndex + (distance < 0 ? 1 : -1));
            window.setTimeout(() => {
              this.suppressBannerLink = false;
            }, 450);
          }
          this.start();
        });
        this.addEventListener('click', (event) => {
          if (!this.suppressBannerLink || !event.target.closest('[data-kas-banner-link]')) return;
          event.preventDefault();
          this.suppressBannerLink = false;
        }, true);
        this.addEventListener('pointercancel', () => {
          this.pointerStartX = null;
          this.suppressBannerLink = false;
          this.start();
        });
        if (this.hoverCapable) {
          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => this.start());
        }
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.start();
        });

        this.kasInitialized = true;
        this.show(this.activeIndex);
      }

      bindDocumentEvents() {
        if (this.documentEventsBound) return;
        document.addEventListener('visibilitychange', this.handleVisibility);
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
        this.documentEventsBound = true;
      }

      unbindDocumentEvents() {
        if (!this.documentEventsBound) return;
        document.removeEventListener('visibilitychange', this.handleVisibility);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
        this.documentEventsBound = false;
      }

      show(requestedIndex) {
        if (this.slides.length < 1) return;
        this.activeIndex = (requestedIndex + this.slides.length) % this.slides.length;
        const activeSlide = this.slides[this.activeIndex];

        this.slides.forEach((slide, index) => {
          const isActive = index === this.activeIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', String(!isActive));
          slide.inert = !isActive;
        });
        this.dots.forEach((dot, index) => {
          const isActive = index === this.activeIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', String(isActive));
        });

        this.style.setProperty('--kas-active-desktop-ratio', activeSlide.dataset.desktopRatio || '2.4');
        this.style.setProperty('--kas-active-mobile-ratio', activeSlide.dataset.mobileRatio || '1.6');
        this.classList.toggle('kas-hero--has-content', activeSlide.dataset.hasContent === 'true');
        if (this.status) this.status.textContent = `${this.activeIndex + 1} / ${this.slides.length}`;
      }

      start() {
        this.stop();
        if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || this.prefersReducedMotion || document.hidden) return;
        this.timer = window.setInterval(() => this.show(this.activeIndex + 1), this.interval);
      }

      stop() {
        window.clearInterval(this.timer);
        this.timer = undefined;
      }
    }

    if (!customElements.get('kas-hero-slider-v2')) {
      customElements.define('kas-hero-slider-v2', KasHeroSliderV2);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kas-product-extras"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kas-product-tabs')) {
    customElements.define('kas-product-tabs', class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.tabs.forEach((tab) => tab.addEventListener('click', () => this.select(tab)));
        this.addEventListener('keydown', (event) => {
          const current = this.tabs.indexOf(document.activeElement);
          if (current < 0 || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'ArrowRight' ? (current + 1) % this.tabs.length : (current - 1 + this.tabs.length) % this.tabs.length;
          this.tabs[next].focus();
          this.select(this.tabs[next]);
        });
      }
      select(selected) {
        this.tabs.forEach((tab) => {
          const active = tab === selected;
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
        });
        this.panels.forEach((panel) => { panel.hidden = panel.id !== selected.getAttribute('aria-controls'); });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
